import { useEffect, useRef, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { invoiceMailContent, paymentConformation, reminderMailContent, debitNoteMailContent, creditNoteMailContent, transactionSummaryMailContent, purchaseMailContent } from '../constants/constant';
import { useSelector } from 'react-redux';
import { handleFreeze } from '../../../utils/common';
import API_ENDPOINTS from '../../../apiEndpoints';
import { showSuccessSnackbar } from '../../../components/snackBar/snakbar';
import {
  useCreateEmailMasterDataMutation,
  useFetchEmailMasterDataQuery,
  useFetchEmailTemplateMasterDataQuery,
} from '../../../redux/apis/emailMaster.api';
import { isValidEmail } from '../../../library/shared';

export const useEmailsettings = ({ select = 1, onSaveComplete, parent }) => {
  let location = useLocation();
  let navigate = useNavigate();
  let selected = select;
  let initial = {
    email: '',
    templateid: '',
    emailbody: '',
    smtp_hostname: '',
    smtp_ports: [],
    smtp_port: '',
    username: '',
    password: '',
    savedPassword: '',
    newPassword: false,
    isUserName: false,
    errorStatus: {
      email: false,
      templateid: false,
      emailbody: false,
      smtp_hostname: false,
      smtp_port: false,
      username: false,
      password: false,
    },
    errorFields: {
      email: '',
      templateid: '',
      emailbody: '',
      smtp_hostname: '',
      smtp_port: '',
      username: '',
      password: '',
    },
  };
  const textAreaRef = useRef();
  const [modalopen, setmodalopen] = useState(false);
  const [allData, setallData] = useState([]);
  const hasProcessedData = useRef(false);
  const lastProcessedTemplateId = useRef(null);
  const lastEmailMasterLength = useRef(0);
  const lastTemplateListLength = useRef(0);

  const [isEditEnabled, setIsEditEnabled] = useState(true);


  function customSplitCamelCase(inputString) {
    return inputString
      .split('_')
      .map((part) => (part === part.toUpperCase() ? part : part.split(/(?=[A-Z])/).join(' ')))
      .join(' _ ')
      .trim();
  }

  const validation = (data) => {
    let valid = true;
    let temp = JSON.parse(JSON.stringify(data));
    Object.keys(temp).map((element) => {
      if (element == 'savedPassword' || element == 'smtp_ports') return;
      if (temp[element] == '' && element !== 'isUserName' && element !== 'newPassword') {
        temp.errorStatus[element] = true;
        temp.errorFields[element] = `${customSplitCamelCase(element)} is required`;
        return (valid = false);
      }
      if (['smtp_hostname', 'smtp_port', 'username', 'password'].indexOf(element) >= 0) {
        if (element === 'password') {
          if (temp.newPassword && temp[element] === '') {
            temp.errorStatus[element] = true;
            temp.errorFields[element] = `${element} is required`;
            valid = false;
            setmodalopen(true);
          } else {
            temp.errorStatus[element] = false;
            temp.errorFields[element] = ``;
          }
        } else if (element == 'smtp_hostname') {
          const smtpRegx = /^(?=.{1,253}$)(?!-)([a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,63}$/;

          if (temp[element] === '') {
            temp.errorStatus[element] = true;
            temp.errorFields[element] = 'Host name cannot be empty';
            return (valid = false);
          } else if (!smtpRegx.test(temp[element])) {
            temp.errorStatus[element] = true;
            temp.errorFields[element] = 'Invalid host name';
            return (valid = false);
          }
        } else if (element === 'smtp_port') {
          const smtpPortRegex = /^(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[1-5]?\d{1,4})$/;
          if (!smtpPortRegex.test(temp[element])) {
            temp.errorStatus[element] = true;
            temp.errorFields[element] = 'Invalid port number';
            return (valid = false);
          }
        }
      } else {
        if (element == 'email') {
          if (!isValidEmail(temp[element])) {
            temp.errorStatus[element] = true;
            temp.errorFields[element] = `This email is invalid !`;
            return (valid = false);
          }
        }
        if (element === 'username') {
          if (element === '') {
            temp.errorStatus[element] = true;
            temp.errorFields[element] = 'username can not be empty';
            return (valid = false);
          }
        }
        if (element === 'password') {
          if (element === '') {
            temp.errorStatus[element] = true;
            temp.errorFields[element] = 'password can not be empty';
            return (valid = false);
          }
        } else {
          temp.errorStatus[element] = false;
          temp.errorFields[element] = ``;
        }
      }
    });
    setData(temp);
    if (valid == false) {
      setmodalopen(true);
    }
    return valid;
  };

  const handleClose = (validate) => {
    if (validate) {
      // validation(data);
      setmodalopen(false);
    } else {
      setmodalopen(false);
    }
  };

  const [data, setData] = useState(initial);
  const [smtpError, setSmtpError] = useState(false);

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name == 'templateid') {
      let emailBody = value === 1 ? invoiceMailContent : value === 2 ? reminderMailContent : value === 3 ? purchaseMailContent : value === 4 ? paymentConformation : value === 5 ? debitNoteMailContent : value === 6 ? creditNoteMailContent : value === 7 ? transactionSummaryMailContent : '';
      let settings = allData.find((element) => element?.templateid == value);
      if (settings) {
        let temp = JSON.parse(JSON.stringify(data));
        let index = allData.indexOf(allData.find((element) => element?.templateid == data.templateid));
        let AllTemp = JSON.parse(JSON.stringify(allData));
        AllTemp[index] = temp;
        setallData(AllTemp);
        setData(settings);
      } else {
        let temp;

        if (name == 'templateid') {
          initial.emailbody = emailBody;
          temp = initial;
        } else {
          temp = initial;
        }
        temp = {
          ...temp,
          [name]: value,
          errorFields: { ...temp.errorFields, [name]: '' },
          errorStatus: { ...temp.errorStatus, [name]: false },
        };
        setallData((prev) => [...prev, temp]);
        setData(temp);
      }
    } else if (name == 'password') {
      if (data.newPassword == false) {
        value = value.length > data.password?.length ? value.replace(data.password, '') : '';
      }
      setData((prev) => ({
        ...prev,
        [name]: value,
        newPassword: true,
        errorFields: { ...prev.errorFields, [name]: '' },
        errorStatus: { ...prev.errorStatus, [name]: false },
      }));
    } else if (name === 'smtp_hostname') {
      const smtpRegx = /^(?=.{1,253}$)(?!-)([a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,63}$/;

      if (value === '') {
        setData((prev) => ({
          ...prev,
          [name]: value,
          errorFields: { ...prev.errorFields, [name]: 'smtp_hostname required' },
          errorStatus: { ...prev.errorStatus, [name]: true },
        }));
      } else if (!smtpRegx.test(value)) {
        setData((prev) => ({
          ...prev,
          [name]: value,
          errorFields: { ...prev.errorFields, [name]: 'Invalid host name' },
          errorStatus: { ...prev.errorStatus, [name]: true },
        }));
        setSmtpError(true);
      } else {
        setData((prev) => ({
          ...prev,
          [name]: value,
          errorFields: { ...prev.errorFields, [name]: '' },
          errorStatus: { ...prev.errorStatus, [name]: false },
        }));
      }
    } else {
      setData((prev) => ({
        ...prev,
        [name]: value,
        errorFields: { ...prev.errorFields, [name]: '' },
        errorStatus: { ...prev.errorStatus, [name]: false },
      }));
    }
  };
  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);

  const saveChanges = async (value) => {
    try {
      if (Freeze === 1) {
        return handleFreeze();
      }
      const tempData = JSON.parse(JSON.stringify(value || data));
      // if (validation(tempData)) {
      let accessToken;
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key.startsWith('CognitoIdentityServiceProvider') && key.endsWith('.accessToken')) {
          accessToken = localStorage.getItem(key);
          break;
        }
      }
      if (tempData?.newPassword) {
        delete tempData.savedPassword;
      } else {
        tempData.password = '';
      }
      delete tempData.newPassword;
      delete tempData.errorFields;
      delete tempData.errorStatus;
      tempData.enteredtimestamp = 0;
      tempData.expiredtimestamp = 0;
      tempData.smtp_port = Number(tempData.smtp_port);

      const body_data = {
        data: tempData,
        authorization: accessToken,
      };
      const option = {
        method: 'POST',
        url: API_ENDPOINTS.REACT_APP_EMAIL_SETTING_URL,
        data: body_data,
        headers: { Authorization: accessToken },
      };

      await createEmailMaster({ data: tempData });
      showSuccessSnackbar('Email Settings Updated !');
      if (location.state) {
        navigate('/PaymentSettings');
      }
      onSaveComplete();
    } catch (error) {
      // Error handling for save operation
    } finally {
    }
  };

  const { data: TemplateList = [], isLoading: loadingTList } = useFetchEmailTemplateMasterDataQuery(undefined, {
    refetchOnMountOrArgChange: false,
  });
  const { data: EmailMaster = [], isLoading: loadingEMaster } = useFetchEmailMasterDataQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const [createEmailMaster, { isLoading: loadingCreateEM }] = useCreateEmailMasterDataMutation();

  useEffect(() => {
    const handleKeyDown = (event) => {
      let id = document.getElementById('Box03');
      if ((event.ctrlKey || event.metaKey) && event.key === 's' && !modalopen && !id) {
        event.preventDefault(); // Prevent the browser's default "save page" behavior
        saveChanges();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    // Cleanup when component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [data, modalopen]);

  useEffect(() => {
    if (parent == 'page') {
    }
    if (loadingTList || loadingEMaster) return;
    
    // Check if data has actually changed by comparing lengths and template ID
    const emailMasterLength = EmailMaster?.length || 0;
    const templateListLength = TemplateList?.length || 0;
    const templateIdChanged = lastProcessedTemplateId.current !== selected;
    const emailMasterChanged = lastEmailMasterLength.current !== emailMasterLength;
    const templateListChanged = lastTemplateListLength.current !== templateListLength;
    
    // Reset processing flag if any relevant data has changed
    if (templateIdChanged || emailMasterChanged || templateListChanged) {
      hasProcessedData.current = false;
      lastProcessedTemplateId.current = selected;
      lastEmailMasterLength.current = emailMasterLength;
      lastTemplateListLength.current = templateListLength;
    }
    
    // Prevent infinite loop by checking if data has already been processed for this template
    if (hasProcessedData.current) return;
    
    let fromMaster = EmailMaster?.length ? true : false;
    let tempdata = JSON.parse(JSON.stringify(TemplateList)).map((elem) => {
      let item = EmailMaster?.find((ele) => String(ele.templateid) === String(elem.templateid));
      if (item) {
        return item;
      } else {
        return elem;
      }
    });
    let temp = tempdata.map((item) => {
      let tempData = JSON.parse(JSON.stringify(initial));
      Object.keys(tempData).forEach((key) => {
        if (key === 'password') {
          tempData.savedPassword = item[key] || '';
          tempData[key] = item[key]?.length ? '********' : '';
        } else {
          tempData[key] = item[key] ? item[key] : tempData[key];
        }
      });
      
      if (!tempData.emailbody || tempData.emailbody === '') {
        // Use the same logic as handleChange function (line 156)
        tempData.emailbody = tempData.templateid === 1 ? invoiceMailContent : 
                           tempData.templateid === 2 ? reminderMailContent : 
                           tempData.templateid === 3 ? purchaseMailContent : 
                           tempData.templateid === 4 ? paymentConformation : 
                           tempData.templateid === 5 ? debitNoteMailContent : 
                           tempData.templateid === 6 ? creditNoteMailContent : 
                           tempData.templateid === 7 ? transactionSummaryMailContent : '';
      }
      return tempData;
    });
    
    // Use selected prop directly instead of data?.templateid to avoid circular dependency
    const currentTemplateId = selected || 1;
    let foundTemplate = temp.find((element) => String(element?.templateid) === String(currentTemplateId));
    
    if (!foundTemplate) {
      const fallbackTemplate = TemplateList?.find((template) => String(template.templateid) === String(currentTemplateId));
      if (fallbackTemplate) {
        let tempData = JSON.parse(JSON.stringify(initial));
        Object.keys(tempData).forEach((key) => {
          if (key === 'password') {
            tempData.savedPassword = fallbackTemplate[key] || '';
            tempData[key] = fallbackTemplate[key]?.length ? '********' : '';
          } else {
            tempData[key] = fallbackTemplate[key] ? fallbackTemplate[key] : tempData[key];
          }
        });
        
        if (!tempData.emailbody || tempData.emailbody === '') {
          // Use the same logic as handleChange function (line 156)
          tempData.emailbody = tempData.templateid === 1 ? invoiceMailContent : 
                             tempData.templateid === 2 ? reminderMailContent : 
                             tempData.templateid === 3 ? purchaseMailContent : 
                             tempData.templateid === 4 ? paymentConformation : 
                             tempData.templateid === 5 ? debitNoteMailContent : 
                             tempData.templateid === 6 ? creditNoteMailContent : 
                             tempData.templateid === 7 ? transactionSummaryMailContent : '';
        }
        foundTemplate = tempData;
      }
    }
    
    if (foundTemplate) {
      setData(foundTemplate);
    } else {
      console.error('No template found for ID:', currentTemplateId);
      // Set a default template with content using the same logic as handleChange function (line 156)
      const defaultTemplate = {
        ...initial,
        templateid: currentTemplateId,
        emailbody: currentTemplateId === 1 ? invoiceMailContent : 
                  currentTemplateId === 2 ? reminderMailContent : 
                  currentTemplateId === 3 ? purchaseMailContent : 
                  currentTemplateId === 4 ? paymentConformation : 
                  currentTemplateId === 5 ? debitNoteMailContent : 
                  currentTemplateId === 6 ? creditNoteMailContent : 
                  currentTemplateId === 7 ? transactionSummaryMailContent : ''
      };
      setData(defaultTemplate);
    }
    
    // Set processed flag and update allData without spreading previous data
    hasProcessedData.current = true;
    setallData(temp);

    if (EmailMaster?.length > 0) {
      setIsEditEnabled(false);
    }
    // document.getElementById("emailTemplates")?.focus();
  }, [loadingEMaster, loadingTList, selected]);

  const handleReset = () => setData((prev) => ({ ...initial }));
  
  const handleOpenEmailSettingsModal = () => setmodalopen(true);
  const handleCloseEmailSettingsModal = () => setmodalopen(false);
  const handleOnApply = (value) => {
    setData((prev) => ({
      ...prev,
      ...value,
    }));
    handleCloseEmailSettingsModal();
  };


  // Function to check if template is saved in EmailMaster - memoized to prevent infinite loops
  const isTemplateSaved = useCallback((templateId) => {
    return EmailMaster?.some((template) => String(template.templateid) === String(templateId));
  }, [EmailMaster]);

  return {
    data,
    allData,
    loadingCreateEM,
    loadingEMaster,
    loadingTList,
    TemplateList,
    EmailMaster,
    textAreaRef,
    modalopen,
    isEditEnabled,
    setData,
    saveChanges,
    handleChange,
    handleClose,
    validation,
    handleReset,
    handleOnApply,
    handleOpenEmailSettingsModal,
    handleCloseEmailSettingsModal,
    setIsEditEnabled,
    isTemplateSaved,
  };
};
